export default "__VITE_ASSET__ffe09348__"